import Help from "./pages/Help/Help";
import AdminHelp from "./pages/AdminHelp/AdminHelp";
import Privacy from "./pages/PrivacyPolicy/PrivacyPolicy";
import Terms from "./pages/Terms/Terms";
import SalesTerms from "./pages/SalesTerms/SalesTerms";
import RediTerms from "./pages/RediTerms/RediTerms";
import NotAvailable from "./pages/NotAvailable/NotAvailable";
import QrNotAvailable from "./pages/QrNotAvailable/QrNotAvailable";

const routes = [
    { path: "/", component: Help, exact: true },
    { path: "/Help", component: Help, exact: true },
    { path: "/Issue/:id", component: AdminHelp, exact: true },
    { path: "/Privacy", component: Privacy, exact: true },
    { path: "/NotAvailable", component: NotAvailable, exact: true },
    { path: "/QRCode", component: QrNotAvailable, exact: true },
    { path: "/Terms", component: Terms, exact: true },
    { path: "/SalesTerms", component: SalesTerms, exact: true },
    { path: "/RediTerms", component: RediTerms, exact: true },
    
];

export default routes;